import { render, staticRenderFns } from "./socialWeal.vue?vue&type=template&id=4addbf86&scoped=true&"
import script from "./socialWeal.vue?vue&type=script&lang=js&"
export * from "./socialWeal.vue?vue&type=script&lang=js&"
import style0 from "./socialWeal.vue?vue&type=style&index=0&id=4addbf86&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4addbf86",
  null
  
)

export default component.exports